import MultiplayerManager from './MultiplayerManager';
import RoomStateStore from './RoomState';

const REPORT_INTERVAL_MS = 500;

class ScoreReporter {
  private active = false;
  private getScoreFn: (() => number) | null = null;
  private interval: ReturnType<typeof setInterval> | null = null;

  start(getScoreFn: () => number): void {
    if (!RoomStateStore.isInRoom) return;
    this.stop();
    this.getScoreFn = getScoreFn;
    this.active = true;

    this.interval = setInterval(() => {
      if (!this.active || !this.getScoreFn) return;
      const score = this.getScoreFn();
      MultiplayerManager.reportScore(score);
    }, REPORT_INTERVAL_MS);
  }

  stop(): void {
    this.active = false;
    this.getScoreFn = null;
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}

export default new ScoreReporter();
